import { LogLevel } from '@nts/std/utility';

export const environment = {
  production: true,
  baseAppUrl: 'https://ntslayoutmanager.ntsinformatica.it/',
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'LayoutManager - DEV',
  appSubTitle: '',
  logLevel: LogLevel.All,
  isEnterpriseBarrierRequired: false
};
